import {
    Component,
    Input,
    Output,
    EventEmitter,
    ElementRef,
    AfterViewInit,
    OnDestroy,
    inject,
    signal,
    ChangeDetectorRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { AlertComponent } from '@pacificspecialtyinsurancecompany/psic-ng-components';
import { globalMessages } from '../global-messages';
import { AnimationComponent } from '../animation/animation.component';

@Component({
    selector: 'app-table-card-layout',
    standalone: true,
    imports: [CommonModule, MatIcon, AlertComponent, AnimationComponent],
    templateUrl: './table-card-layout.component.html',
    styleUrl: './table-card-layout.component.scss',
})
export class TableCardLayoutComponent implements AfterViewInit, OnDestroy {
    @Input() title = '';
    @Input() isLoading = false;
    @Input() failed = false;
    @Input() hasData = true;
    @Input() noDataMessage = globalMessages.noDataAvailabelMsg;
    @Input() errorMessage = globalMessages.serviceMsgError;
    @Output() retry = new EventEmitter<void>();
    compactBreakpoint = globalMessages.compactBreakpoint;

    isCompact = signal(false);

    private el = inject(ElementRef);
    private cdr = inject(ChangeDetectorRef);
    private resizeObserver: ResizeObserver | null = null;

    ngAfterViewInit() {
        if (this.compactBreakpoint <= 0) return;
        const target = this.el.nativeElement.querySelector('.cardLayout');
        if (!target) return;
        this.resizeObserver = new ResizeObserver((entries) => {
            const width = entries[0].contentRect.width;
            if (width === 0) return;
            const compact = width < this.compactBreakpoint;
            if (compact !== this.isCompact()) {
                this.isCompact.set(compact);
                this.cdr.markForCheck();
            }
        });
        this.resizeObserver.observe(target);
    }

    ngOnDestroy() {
        this.resizeObserver?.disconnect();
    }
}
